import React from 'react'
import { Link } from 'react-router-dom'
import { Translate, I18n } from 'react-redux-i18n'

import Form from './form'

export default () => (
  <div>
    <h2>
      <Translate value="users.confirmation.h" />
    </h2>
    <p className="text-center">
      <Translate value="users.sign_up.have_account" />{' '}
      <Link to="/users/sign_in">
        <b>{I18n.t('users.common.sign_in')}</b>
      </Link>
    </p>
    <Form />
  </div>
)



// WEBPACK FOOTER //
// ./src/containers/pages/users/confirmation/index.js